import { render, staticRenderFns } from "./AttributeFamily.vue?vue&type=template&id=b7de1876&"
import script from "./AttributeFamily.vue?vue&type=script&lang=js&"
export * from "./AttributeFamily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports